import { Product } from "@transfr-inc/dashboard-components/constants";
import {
  Column,
  ColumnOptions,
  ColumnType,
  TableCellListContent,
} from "@transfr-inc/dashboard-components/data-table";

import { ColumnHeaderInformationTooltip } from "@components/custom/content/column-header-information-tooltip";
import { CheckedCell } from "@components/table-cells";

const tsColumnsDefinition = [
  new Column(
    "totalCompleted",
    "Sims Completed",
    ColumnType.BASIC,
    new ColumnOptions({ sortingEnabled: true })
  ),
  new Column(
    "totalMastered",
    "Sims Mastered",
    ColumnType.BASIC,
    new ColumnOptions({ sortingEnabled: true })
  ),
];

const ceColumnsDefinition = [
  new Column(
    "totalCompleted",
    (
      <ColumnHeaderInformationTooltip
        headerTitle={"Careers Explored"}
        tooltipText={"Careers completed in the headset"}
      ></ColumnHeaderInformationTooltip>
    ),
    ColumnType.BASIC,
    new ColumnOptions({ sortingEnabled: true })
  ),
  new Column(
    "topCareers",
    "Top Careers",
    ColumnType.CUSTOM,
    new ColumnOptions({
      sortingEnabled: true,
      customFunction: (value, row) => {
        return (
          <TableCellListContent
            collection={row.topCareers?.length > 0 ? row.topCareers : undefined}
            collectionCount={value}
          />
        );
      },
    })
  ),
];

const trekColumnsDefinition = [
  new Column(
    "careersViewed",
    (
      <ColumnHeaderInformationTooltip
        headerTitle="Careers Viewed"
        tooltipText="Careers viewed in Trek"
      />
    ),
    ColumnType.BASIC,
    new ColumnOptions({ sortingEnabled: true })
  ),
  new Column(
    "budgetPlans",
    "Budgets Created",
    ColumnType.CUSTOM,
    new ColumnOptions({
      sortingEnabled: true,
      customFunction: (value, row) => {
        const count = (value ?? []).filter(
          (bp) => !!bp.budgetCompletedAt
        ).length;
        return <CheckedCell value={row.isBudgetCreated} count={count} />;
      },
    })
  ),
  ({ onClick }) =>
    new Column(
      "careerPlans",
      "Pathways Selected",
      ColumnType.CUSTOM,
      new ColumnOptions({
        sortingEnabled: true,
        customFunction: (_value, row) => {
          const count = row.careerPlans?.length ?? 0;

          return (
            <CheckedCell
              value={row.isSelected}
              count={count}
              onClick={() => {
                onClick(row.userId);
              }}
            />
          );
        },
      })
    ),
];

const columnsDefinitionMap = new Map();
columnsDefinitionMap.set(Product.TS, tsColumnsDefinition);
columnsDefinitionMap.set(Product.CE, ceColumnsDefinition);
columnsDefinitionMap.set(Product.TRK, trekColumnsDefinition);
columnsDefinitionMap.set(Product.CE_TRK, trekColumnsDefinition);
columnsDefinitionMap.set(Product.PROG, tsColumnsDefinition);

export const getColumnsDefinitionByProduct = (productId) =>
  columnsDefinitionMap.get(productId);
